let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lc4xj")).then(() => parcelRequire('jaNQU'));